import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { Toaster, toast } from 'react-hot-toast';
import Select from "react-select";

function Register() {
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [showPassword, setShowPassword] = useState(false)
  const [showPassword1, setShowPassword1] = useState(false)
  const [error, setError] = useState(false);
  const [error1, setError1] = useState(false);
  const [error2, setError2] = useState(false);
  const [errorValue, setErrorValue] = useState();
  const [errorValue1, setErrorValue1] = useState();
  const [errorValue2, setErrorValue2] = useState();
  const countryoptions = [
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Albania", label: "Albania" },
    { value: "Algeria", label: "Algeria" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Antigua-and-barbuda", label: "Antigua and Barbuda" },
    { value: "Argentina", label: "Argentina" },
    { value: "Armenia", label: "Armenia" },
    { value: "Australia", label: "Australia" },
    { value: "Austria", label: "Austria" },
    { value: "Azerbaijan", label: "Azerbaijan" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgium", label: "Belgium" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivia", label: "Bolivia" },
    { value: "Bosnia-and-herzegovina", label: "Bosnia and Herzegovina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Brazil", label: "Brazil" },
    { value: "Brunei", label: "Brunei" },
    { value: "Bulgaria", label: "Bulgaria" },
    { value: "Burkina-faso", label: "Burkina Faso" },
    { value: "Burundi", label: "Burundi" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Cameroon", label: "Cameroon" },
    { value: "Canada", label: "Canada" },
    { value: "Cape-verde", label: "Cape Verde" },
    { value: "Central-african-republic", label: "Central African Republic" },
    { value: "Chad", label: "Chad" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "Colombia", label: "Colombia" },
    { value: "Comoros", label: "Comoros" },
    { value: "Congo", label: "Congo" },
    { value: "Costa-rica", label: "Costa Rica" },
    { value: "Croatia", label: "Croatia" },
    { value: "Cuba", label: "Cuba" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Czech-republic", label: "Czech Republic" },
    { value: "Denmark", label: "Denmark" },
    { value: "Djibouti", label: "Djibouti" },
    { value: "Dominica", label: "Dominica" },
    { value: "Dominican-republic", label: "Dominican Republic" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Egypt", label: "Egypt" },
    { value: "El-salvador", label: "El Salvador" },
    { value: "Equatorial-guinea", label: "Equatorial Guinea" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estonia", label: "Estonia" },
    { value: "Eswatini", label: "Eswatini" },
    { value: "Ethiopia", label: "Ethiopia" },
    { value: "Fiji", label: "Fiji" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "France" },
    { value: "Gabon", label: "Gabon" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgia", label: "Georgia" },
    { value: "Germany", label: "Germany" },
    { value: "Ghana", label: "Ghana" },
    { value: "Greece", label: "Greece" },
    { value: "Grenada", label: "Grenada" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guinea", label: "Guinea" },
    { value: "Guinea-bissau", label: "Guinea-Bissau" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    { value: "Honduras", label: "Honduras" },
    { value: "Hungary", label: "Hungary" },
    { value: "Iceland", label: "Iceland" },
    { value: "India", label: "India" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Iran", label: "Iran" },
    { value: "Iraq", label: "Iraq" },
    { value: "Ireland", label: "Ireland" },
    { value: "Israel", label: "Israel" },
    { value: "Italy", label: "Italy" },
    { value: "Jamaica", label: "Jamaica" },
    { value: "Japan", label: "Japan" },
    { value: "Jordan", label: "Jordan" },
    { value: "Kazakhstan", label: "Kazakhstan" },
    { value: "Kenya", label: "Kenya" },
    { value: "Kiribati", label: "Kiribati" },
    { value: "Korea-north", label: "North Korea" },
    { value: "Korea-south", label: "South Korea" },
    { value: "Kosovo", label: "Kosovo" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
    { value: "Laos", label: "Laos" },
    { value: "Latvia", label: "Latvia" },
    { value: "Lebanon", label: "Lebanon" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libya", label: "Libya" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Madagascar", label: "Madagascar" },
    { value: "Malawi", label: "Malawi" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Maldives", label: "Maldives" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marshall-islands", label: "Marshall Islands" },
    { value: "Mauritania", label: "Mauritania" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mexico", label: "Mexico" },
    { value: "Micronesia", label: "Micronesia" },
    { value: "Moldova", label: "Moldova" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolia", label: "Mongolia" },
    { value: "Montenegro", label: "Montenegro" },
    { value: "Morocco", label: "Morocco" },
    { value: "Mozambique", label: "Mozambique" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Namibia", label: "Namibia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "New-zealand", label: "New Zealand" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "North-macedonia", label: "North Macedonia" },
    { value: "Norway", label: "Norway" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Palau", label: "Palau" },
    { value: "Panama", label: "Panama" },
    { value: "Papua-new-guinea", label: "Papua New Guinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Philippines", label: "Philippines" },
    { value: "Poland", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Qatar", label: "Qatar" },
    { value: "Romania", label: "Romania" },
    { value: "Russia", label: "Russia" },
    { value: "Rwanda", label: "Rwanda" },
    { value: "Saint-kitts-and-nevis", label: "Saint Kitts and Nevis" },
    { value: "Saint-lucia", label: "Saint Lucia" },
    { value: "Saint-vincent-and-the-grenadines", label: "Saint Vincent and the Grenadines" },
    { value: "Samoa", label: "Samoa" },
    { value: "San-marino", label: "San Marino" },
    { value: "Sao-tome-and-principe", label: "Sao Tome and Principe" },
    { value: "Saudi-arabia", label: "Saudi Arabia" },
    { value: "Senegal", label: "Senegal" },
    { value: "Serbia", label: "Serbia" },
    { value: "Seychelles", label: "Seychelles" },
    { value: "Sierra-leone", label: "Sierra Leone" },
    { value: "Singapore", label: "Singapore" },
    { value: "Slovakia", label: "Slovakia" },
    { value: "Slovenia", label: "Slovenia" },
    { value: "Solomon-islands", label: "Solomon Islands" },
    { value: "Somalia", label: "Somalia" },
    { value: "South-africa", label: "South Africa" },
    { value: "South-sudan", label: "South Sudan" },
    { value: "Spain", label: "Spain" },
    { value: "Sri-lanka", label: "Sri Lanka" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suriname", label: "Suriname" },
    { value: "Sweden", label: "Sweden" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Syria", label: "Syria" },
    { value: "Taiwan", label: "Taiwan" },
    { value: "Tajikistan", label: "Tajikistan" },
    { value: "Tanzania", label: "Tanzania" },
    { value: "Thailand", label: "Thailand" },
    { value: "Togo", label: "Togo" },
    { value: "Tonga", label: "Tonga" },
    { value: "Trinidad-and-tobago", label: "Trinidad and Tobago" },
    { value: "Tunisia", label: "Tunisia" },
    { value: "Turkey", label: "Turkey" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "United-arab-emirates", label: "United Arab Emirates" },
    { value: "United-kingdom", label: "United Kingdom" },
    { value: "United-states", label: "United States" },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Uzbekistan", label: "Uzbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    { value: "Vatican-city", label: "Vatican City" },
    { value: "Venezuela", label: "Venezuela" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Yemen", label: "Yemen" },
    { value: "Zambia", label: "Zambia" },
    { value: "Zimbabwe", label: "Zimbabwe" },
    { value: "Crypto", label: "Crypto" }
  ];
  const currencyoptions = [
    { value: "USD", label: "USD (US Dollar)" },
    { value: "EUR", label: "EUR (Euro)" },
    { value: "GBP", label: "GBP (British Pound)" },
    { value: "AUD", label: "AUD (Australian Dollar)" },
    { value: "CAD", label: "CAD (Canadian Dollar)" },
    { value: "CHF", label: "CHF (Swiss Franc)" },
    { value: "CNY", label: "CNY (Chinese Yuan)" },
    { value: "INR", label: "INR (Indian Rupee)" },
    { value: "JPY", label: "JPY (Japanese Yen)" },
    { value: "RUB", label: "RUB (Russian Ruble)" },
    { value: "ZAR", label: "ZAR (South African Rand)" },
  ];
  const genderoptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];
  const leverageoptions = [
    { value: "1.1", label: "1.1" },
    { value: "1.5", label: "1.5" },
    { value: "1.15", label: "1.15" },
    { value: "1.20", label: "1.20" },
    { value: "1.33", label: "1.33" },
    { value: "1.50", label: "1.50" },
    { value: "1.100", label: "1.100" },
    { value: "1.200", label: "1.200" },
    { value: "1.400", label: "1.400" },
    { value: "1.500", label: "1.500" },
  ];
  const accounttypes = [
    { value: "CRYPTO", label: "CRYPTO" },
    { value: "STOCKS", label: "STOCKS" },
    { value: "FOREX", label: "FOREX" },
    { value: "OPTIONS", label: "OPTIONS" },
    { value: "FUTURES", label: "FUTURES" },
    { value: "OTHERS", label: "OTHERS" },
  ];
  const [selectplans, setSelectplans] = useState([]);
  const [plans, setPlans] = useState([]);
  const [type, setType] = useState("");
  const [leverage, setLeverage] = useState("");
  
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/register.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchPlan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const mappedPlans = data.plans.map(plan => ({
          value: plan.subscribe_id,
          label: plan.subscribe_name
        }));
        setPlans(mappedPlans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching signals!')
    })
  }, []);

  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const [openref, setOpenref] = useState(false);
  const [ref, setRef] = useState("");
  const [fullname, setFullname] = useState("")
  const [gender, setGender] = useState("")
  const [currency, setCurrency] = useState("USD")
  const [username, setUsername] = useState("")
  const [phone, setPhone] = useState("")
  const [country, setCountry] = useState("")
  const [email, setEmail] = useState("")
  const [pass1, setPass1] = useState("")
  const [pass2, setPass2] = useState("")
  useEffect(() => {
    if(fullname && gender && currency && username && phone && country && email && pass1 && pass2 && selectplans && type && leverage){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [fullname, gender, currency, username, phone, country, email, pass1, pass2, selectplans, type, leverage]);

  function validatePass1 (value){
    setPass1(value);
    if (value.length < 8) {
        setError1(true);
        setErrorValue1("Password must be at least 8 characters long.");
    } else {
        setError1(false);
        setErrorValue1("");
    }
  }
  function validatePass2 (value){
    setPass2(value);
    if (value !== pass1) {
        setError2(true);
        setErrorValue2("Passwords do not match.");
    } else {
        setError2(false);
        setErrorValue2("");
    }
  }
  function validateEmail (value){
    setEmail(value);
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        setError(true);
        setErrorValue("Please enter a valid email address");
    } else {
        setError(false);
        setErrorValue("");
    }
  }

  const handleRegistration = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/register.controller.php`, {
      credentials: "include",   
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ register: true, email: email, username: username, gender: gender, phone: phone, fullname: fullname, country: country, plan: selectplans, type: type, leverage: leverage, currency: currency, pass1: pass1, pass2: pass2, ref: ref || false})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "login";
        }, 3000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  } 

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
      <div><Toaster/></div>
      <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
          Back to homepage
        </Link>
      </header>
      <main className="flex-grow-1 d-flex justify-content-center p-3 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5 col-xl-4">
              <div className="mb-4">
                <h1 className="fs-4 fw-semibold">Create a new account</h1>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control py-2"
                    placeholder="Fullname"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control py-2"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                    <Select 
                        options={genderoptions} 
                        value={genderoptions.find((opt) => opt.value === gender)}
                        onChange={(e) => setGender(e.value)}
                        styles={darkThemeStyles}
                        className="w-full"
                        placeholder="Select Gender"
                    />
                </div>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type="email"
                    className="form-control py-2"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => validateEmail(e.target.value)}
                    required
                  />
                </div>
                {error && (
                  <p className="mb-0 text-danger fs-7 mt-1">{errorValue}</p>
                )}
              </div>
              <div className="mb-3">
                <div className="position-relative">
                    <Select 
                        options={accounttypes} 
                        value={accounttypes.find((opt) => opt.value === type)}
                        onChange={(e) => setType(e.value)}
                        styles={darkThemeStyles}
                        className="w-full"
                        placeholder="Choose an Account Type"
                    />
                </div>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                    <Select 
                        options={plans} 
                        value={plans.find((opt) => opt.value === selectplans)}
                        onChange={(e) => setSelectplans(e.value)}
                        styles={darkThemeStyles}
                        className="w-full"
                        placeholder="Choose a plan"
                    />
                </div>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                    <Select 
                        options={leverageoptions} 
                        value={leverageoptions.find((opt) => opt.value === leverage)}
                        onChange={(e) => setLeverage(e.value)}
                        styles={darkThemeStyles}
                        className="w-full"
                        placeholder="Choose Leverage"
                    />
                </div>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                    <Select 
                        options={countryoptions} 
                        value={countryoptions.find((opt) => opt.value === country)}
                        onChange={(e) => setCountry(e.value)}
                        styles={darkThemeStyles}
                        className="w-full"
                        placeholder="Select Country"
                    />
                </div>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control py-2"
                    placeholder="Phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control py-2"
                    placeholder="Password (min. of 6 characters)"
                    value={pass1}
                    onChange={(e) => validatePass1(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-secondary"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ zIndex: 5 }}
                  >
                    {showPassword ? <FontAwesomeIcon icon={faEyeSlash} size={16}/> : <FontAwesomeIcon icon={faEye} size={16}/>}
                  </button>
                </div>
                {error1 && (
                  <p className="mb-0 text-danger fs-7 mt-1">{errorValue1}</p>
                )}
              </div>
              <div className="mb-3">
                <div className="position-relative">
                  <input
                    type={showPassword1 ? "text" : "password"}
                    className="form-control py-2"
                    placeholder="Repeat your password"
                    value={pass2}
                    onChange={(e) => validatePass2(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-secondary"
                    onClick={() => setShowPassword1(!showPassword1)}
                    style={{ zIndex: 5 }}
                  >
                    {showPassword1 ? <FontAwesomeIcon icon={faEyeSlash} size={16}/> : <FontAwesomeIcon icon={faEye} size={16}/>}
                  </button>
                </div>
                {error2 && (
                  <p className="mb-0 text-danger fs-7 mt-1">{errorValue2}</p>
                )}
              </div>
              <div className="mb-3">
                <div className="position-relative">
                    <Select 
                        options={currencyoptions} 
                        value={currencyoptions.find((opt) => opt.value === currency)}
                        onChange={(e) => setCurrency(e.value)}
                        styles={darkThemeStyles}
                        className="w-full"
                        placeholder="Select Currency"
                    />
                </div>
              </div>
              <div className="d-flex flex-column my-4">
                <p className="text-prime fw-bold mb-2 noLink" onClick={() => setOpenref(!openref)}>
                  Have a referral code?
                </p>
                {openref && (
                <div className="mb-3">
                    <div className="position-relative">
                    <input
                        type="text"
                        className="form-control py-2"
                        placeholder="Referral code (optional)"
                        value={ref}
                        onChange={(e) => setRef(e.target.value)}
                        required
                    />
                    </div>
                </div>
                )}
                <Link to="/login" className="text-prime fw-bold mb-2 noLink">
                    Already have an account?
                </Link>
              </div>
              <div className={`btn btn-secondary w-100 py-2 fw-bold ${disable?'disabled':null}`} onClick={!disable ? handleRegistration : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Create account'}</div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Register